export const style = {
  fileAlertWrapper: {
    margin: 0,
    padding: `8px 15px`,
    boxShadow: `0px 8px 17px 0px rgba(0,0,0,0.15)`,
    transition: `all 0.2s`,
    maxHeight: `999px`,
    overflow: `hidden`
  },
  hide: {
    maxHeight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    boxShadow: `none`
  },
  danger: {
    background: `#AD5251`
  },
  success: {
    background: `#4eaf74`
  },
  info: {
    background: `#0b93f2`
  },
  fileAlertBox: {
    padding: 0
  },
  fileAlertSpan: {
    color: `white`,
    fontSize: `14px`
  },
  fileAlertCloseButton: {
    position: `absolute`,
    right: 0
  },
  fileAlertCloseIcon: {
    fontSize: `16px`,
    fontWeight: `600`,
    color: `white`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/ResponseAlert/style/alert.js